import PropTypes from 'prop-types';
import React from 'react';

const DragOverlayContent = ({ dragData }) => {
  if (!dragData) return null;

  const { items } = dragData;

  if (items.length === 1) {
    const foldered = items[0];
    const iconClass = foldered.item.is_folder
      ? "fas fa-folder"
      : ("fas " + foldered.item.fontawesome_icon_class);

    return (
      <div className="d-flex align-items-center px-3 py-2 bg-white rounded shadow drag-overlay-pill">
        <i className={iconClass + " text-primary mr-2"}></i>
        <strong>{foldered.item.human_file_name}</strong>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center px-3 py-2 bg-white rounded shadow drag-overlay-pill">
      <i className="fas fa-copy text-primary mr-2"></i>
      <strong>{items.length} items</strong>
    </div>
  );
};

DragOverlayContent.propTypes = {
  dragData: PropTypes.shape({
    items: PropTypes.array.isRequired
  })
};

export default DragOverlayContent;
